import { useMutation } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetAllContactUs() {
  return useMutation({
    mutationFn: ({ page, limit, search, subject, status, role }) => {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit)
      });

      if (search) {
        params.append("search", search);
      }

      // Always send subject parameter (default to 'all' if not provided)
      params.append("subject", subject || "all");

      // Always send status parameter (default to 'all' if not provided)
      params.append("status", status || "all");

      // Always send role parameter (default to 'all' if not provided)
      params.append("role", role || "all");

      return apiClient({
        url: `admin/contact-us/all?${params.toString()}`,
        method: "GET"
      });
    }
  });
}

export function useCreateContactUS() {
  return useMutation({
    mutationFn: (payload) => apiClient({ url: "contact-us", method: "POST", data: payload })
  });
}

export function useUpdateContactUS() {
  return useMutation({
    mutationFn: ({ ticketId, payload }) =>
      apiClient({ url: `admin/contact-us/update/${ticketId}`, method: "PATCH", data: payload })
  });
}
